/* Cãomigo — lógica da página "rolo" (igual à do Claude Design, canvas "Rolo tira-pelos lavável"). Precisa de cmg-dc.js antes. */
(function () {
class Component extends DCLogic {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, this.state || {}, {
      img: 0, open: {}, cart: 0, added: false, par: false, bump: false, menu: false,
      seen: {}, armed: false, bar: false, live: '',
      dmMsg: 'Carrega e arrasta sobre o tecido.', dmCheio: false, hint: true
    });
    var self = this;
    this.setRoot = function (el) { self.rootEl = el; };
    this.setCv = function (el) { self.cv = el; };
    this.setCta = function (el) { self.ctaEl = el; };
    ['dmDown', 'dmMove', 'dmUp', 'dmLeave', 'dmKey', 'lavar', 'recomecar', 'add', 'addPar', 'toggleMenu', 'tick'].forEach(function (k) { self[k] = self[k].bind(self); });
    this.tLavar = function () { self.toggle('lavar'); };
    this.tCaixa = function () { self.toggle('caixa'); };
    this.tEnvio = function () { self.toggle('envio'); };
    this.picks = [0, 1, 2, 3].map(function (i) { return function () { self.setState({ img: i }); }; });
    this.GAL = [
      { t: 'Branco.', d: 'Fechado e aberto: o estojo protege o rolo quando não o usas.', alt: 'Rolo tira-pelos branco, fechado e aberto, sobre fundo claro.' },
      { t: 'No banco de trás.', d: 'Passa o rolo pela capa e os pelos ficam colados.', alt: 'Mão a passar o rolo na capa preta de banco traseiro, com um cão sentado ao lado.' },
      { t: 'Na forra.', d: 'Apanha o pelo que fica na mala depois da viagem.', alt: 'Rolo aberto, com pelos, sobre a forra preta com debrum laranja, com a mala aberta para o pinhal.' },
      { t: 'Pequeno.', d: '10,1 × 6,5 cm: cabe na mão e no bolso da porta.', alt: 'Rolo fechado na palma da mão, junto à porta aberta do carro.' }
    ];
  }

  /* ---------- UI ---------- */
  toggle(id) { var o = Object.assign({}, this.state.open); o[id] = !o[id]; this.setState({ open: o }); }
  toggleMenu() { this.setState({ menu: !this.state.menu }); }
  add() {
    var self = this;
    this.setState({ cart: this.state.cart + 1, added: true, bump: true, live: 'Rolo tira-pelos lavável adicionado ao carrinho.' });
    clearTimeout(this._tA); clearTimeout(this._tB);
    this._tA = setTimeout(function () { self.setState({ added: false }); }, 1800);
    this._tB = setTimeout(function () { self.setState({ bump: false }); }, 460);
  }
  addPar() {
    if (this.state.par) return;
    var self = this;
    this.setState({ cart: this.state.cart + 1, par: true, bump: true, live: 'Capa de banco traseiro adicionada ao carrinho.' });
    clearTimeout(this._tB);
    this._tB = setTimeout(function () { self.setState({ bump: false }); }, 460);
  }

  componentDidMount() {
    var self = this;
    this.reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var root = this.rootEl;
    var scrolls = document.documentElement.scrollHeight > (window.innerHeight || 0) + 80;
    if (root && scrolls && 'IntersectionObserver' in window && !this.reduce) {
      var vh = window.innerHeight || 800, seen = {};
      var els = root.querySelectorAll('[data-rv]');
      this.io = new IntersectionObserver(function (es) {
        var add = {}, n = 0;
        es.forEach(function (e) { if (e.isIntersecting) { add[e.target.getAttribute('data-rv')] = true; self.io.unobserve(e.target); n++; } });
        if (n) self.setState(function (s) { return { seen: Object.assign({}, s.seen, add) }; });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.top < vh * 0.92) seen[els[i].getAttribute('data-rv')] = true; else this.io.observe(els[i]);
      }
      this.setState({ seen: seen, armed: true });
    }
    if (this.ctaEl && 'IntersectionObserver' in window) {
      this.io2 = new IntersectionObserver(function (es) {
        var e = es[0]; var off = !e.isIntersecting && e.boundingClientRect.top < 0;
        if (off !== self.state.bar) self.setState({ bar: off });
      }, { threshold: 0 });
      this.io2.observe(this.ctaEl);
    }
    this.initDemo();
  }
  componentWillUnmount() {
    if (this.io) this.io.disconnect();
    if (this.io2) this.io2.disconnect();
    if (this.ro) this.ro.disconnect();
    if (this.onWin) window.removeEventListener('resize', this.onWin);
    if (this.raf) cancelAnimationFrame(this.raf);
    clearTimeout(this._tA); clearTimeout(this._tB);
  }

  /* ---------- demonstração ---------- */
  rng(seed) { var a = seed >>> 0; return function () { a = (a + 0x6D2B79F5) >>> 0; var t = a; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; }
  gauss(r) { var u = 1 - r(), v = r(); return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v); }
  seedHairs(seed, appear) {
    var r = this.rng(seed), n = Math.max(40, Math.min(600, this.props.pelos != null ? this.props.pelos : 260));
    var C = [[.36, .56, .17, .2], [.62, .40, .16, .16], [.52, .66, .24, .2], [.24, .30, .12, .12]];
    var cols = ['#EFE6D6', '#E2D3BA', '#F6F0E4', '#D6C3A2', '#C9B48F'];
    var hs = [];
    while (hs.length < n) {
      var c = C[Math.floor(r() * C.length)];
      var x = c[0] + this.gauss(r) * c[2], y = c[1] + this.gauss(r) * c[3];
      if (x < .03 || x > .97 || y < .04 || y > .96) continue;
      hs.push({ x: x, y: y, a: r() * Math.PI * 2, l: 9 + r() * 17, b: (r() - .5) * 12, w: 1.2 + r() * 1.3, c: cols[Math.floor(r() * cols.length)], o: .6 + r() * .38, alive: true, t: appear && !this.reduce ? 0 : 1, fly: null });
    }
    this.hairs = hs; this.nH = n; this.rnd = r;
  }
  initDemo() {
    var cv = this.cv; if (!cv || !cv.getContext) return;
    this.ctx = cv.getContext('2d');
    this.seedHairs(11, false);
    this.rl = { x: .70, y: .44, load: 0, marks: [], wash: 0 };
    this.fit();
    var self = this;
    if (window.ResizeObserver) { this.ro = new ResizeObserver(function () { self.fit(); }); this.ro.observe(cv); }
    else { this.onWin = function () { self.fit(); }; window.addEventListener('resize', this.onWin); }
  }
  fit() {
    var cv = this.cv; if (!cv) return;
    var w = cv.clientWidth, h = cv.clientHeight; if (!w || !h) return;
    var d = Math.min(2, window.devicePixelRatio || 1);
    this.W = w; this.H = h; this.dpr = d;
    cv.width = Math.round(w * d); cv.height = Math.round(h * d);
    this.k = Math.max(.62, Math.min(1.2, w / 820));
    this.RL = Math.max(120, Math.min(250, w * .3));
    this.RT = this.RL * .3;
    var b = document.createElement('canvas'); b.width = cv.width; b.height = cv.height;
    var g = b.getContext('2d'); g.setTransform(d, 0, 0, d, 0, 0);
    g.fillStyle = '#242321'; g.fillRect(0, 0, w, h);
    g.strokeStyle = 'rgba(255,255,255,.028)'; g.lineWidth = 1; g.beginPath();
    for (var i = -h; i < w; i += 5) { g.moveTo(i, 0); g.lineTo(i + h, h); }
    g.stroke();
    var st = 118 * this.k;
    for (var j = -h; j < w + h; j += st) {
      g.setLineDash([]); g.strokeStyle = 'rgba(0,0,0,.42)'; g.lineWidth = 3 * this.k;
      g.beginPath(); g.moveTo(j, 0); g.lineTo(j + h, h); g.moveTo(j, h); g.lineTo(j + h, 0); g.stroke();
      g.setLineDash([6 * this.k, 6 * this.k]); g.strokeStyle = 'rgba(255,255,255,.09)'; g.lineWidth = 1.3 * this.k;
      g.beginPath(); g.moveTo(j + 3, 0); g.lineTo(j + 3 + h, h); g.moveTo(j + 3, h); g.lineTo(j + 3 + h, 0); g.stroke();
    }
    g.setLineDash([]);
    this.bgc = b;
    if (!this.pre) {
      this.pre = true;
      this.sweep(.16, .74, .70, .44, true);
      this.rl.load = Math.min(this.rl.load, .24);
      this.rl.marks.length = Math.min(this.rl.marks.length, 18);
    }
    this.draw();
  }
  pickAt(px, py, silent) {
    var W = this.W, H = this.H, hx = this.RL * .47, hy = this.RT * .62, rl = this.rl, r = this.rnd, cap = Math.max(40, this.nH * .38);
    for (var i = 0; i < this.hairs.length; i++) {
      var h = this.hairs[i]; if (!h.alive) continue;
      var dx = h.x * W - px, dy = h.y * H - py;
      if (dx > -hx && dx < hx && dy > -hy && dy < hy) {
        var stick = Math.max(.07, 1 - Math.pow(rl.load, 1.5));
        if (r() < stick * .85) {
          h.alive = false;
          if (silent || this.reduce) h.t = 0; else { h.fly = { x0: h.x * W, y0: h.y * H, x1: px + dx * .35, y1: py }; h.t = 1; this.anim = true; }
          rl.load = Math.min(1, rl.load + 1 / cap);
          if (rl.marks.length < 80) rl.marks.push({ x: r() - .5, y: r() - .5, a: r() * Math.PI, l: .04 + r() * .06, c: r() < .5 ? '#8C7B60' : '#A8977A' });
        }
      }
    }
  }
  sweep(x0, y0, x1, y1, silent) {
    if (!this.W) return;
    var W = this.W, H = this.H, ax = x0 * W, ay = y0 * H, bx = x1 * W, by = y1 * H;
    var dist = Math.hypot(bx - ax, by - ay), n = Math.max(1, Math.ceil(dist / (this.RT * .3)));
    for (var i = 1; i <= n; i++) { var t = i / n; this.pickAt(ax + (bx - ax) * t, ay + (by - ay) * t, silent); }
    this.rl.x = x1; this.rl.y = y1;
    this.kick();
  }
  pt(e) { var b = this.cv.getBoundingClientRect(); return { x: Math.max(0, Math.min(1, (e.clientX - b.left) / b.width)), y: Math.max(0, Math.min(1, (e.clientY - b.top) / b.height)) }; }
  dmDown(e) {
    if (!this.W) return;
    try { this.cv.setPointerCapture(e.pointerId); } catch (x) {}
    this.drag = true; var p = this.pt(e);
    this.sweep(p.x, p.y, p.x, p.y, false); this.last = p;
    if (this.state.hint) this.setState({ hint: false });
    this.status();
  }
  dmMove(e) {
    if (!this.W) return;
    var p = this.pt(e);
    if (this.drag) { this.sweep(this.last.x, this.last.y, p.x, p.y, false); this.last = p; this.status(); }
    else if (e.pointerType === 'mouse') { this.rl.x = p.x; this.rl.y = p.y; this.kick(); }
  }
  dmUp() { this.drag = false; }
  dmLeave() { if (!this.drag) this.kick(); }
  dmKey(e) {
    var k = e.key, s = .045, dx = 0, dy = 0;
    if (k === 'ArrowLeft') dx = -s; else if (k === 'ArrowRight') dx = s; else if (k === 'ArrowUp') dy = -s; else if (k === 'ArrowDown') dy = s; else return;
    e.preventDefault();
    var x = Math.max(0, Math.min(1, this.rl.x + dx)), y = Math.max(0, Math.min(1, this.rl.y + dy));
    this.sweep(this.rl.x, this.rl.y, x, y, false);
    if (this.state.hint) this.setState({ hint: false });
    this.status();
  }
  lavar() {
    if (!this.rl) return;
    if (this.reduce) { this.rl.load = 0; this.rl.marks = []; this.washed = true; this.rl.x = Math.min(.82, Math.max(.18, this.rl.x)); this.rl.y = Math.min(.8, Math.max(.2, this.rl.y)); this.kick(); this.status(); return; }
    this.rl.wash = 1; this.washFrom = this.rl.load; this.washed = true; this.anim = true;
    this.rl.x = Math.min(.82, Math.max(.18, this.rl.x)); this.rl.y = Math.min(.8, Math.max(.2, this.rl.y));
    this.kick();
  }
  recomecar() {
    if (!this.rl) return;
    this.seedHairs(11 + Math.floor(Math.random() * 1000), true);
    this.rl.load = 0; this.rl.marks = []; this.rl.x = .70; this.rl.y = .44; this.washed = false;
    this.anim = !this.reduce; this.kick();
    this.setState({ dmMsg: 'Carrega e arrasta sobre o tecido.', dmCheio: false, hint: true });
  }
  status() {
    var rl = this.rl; if (!rl) return;
    var alive = 0; for (var i = 0; i < this.hairs.length; i++) if (this.hairs[i].alive) alive++;
    var m, cheio = false;
    if (alive < this.nH * .03) m = 'Tecido limpo. Espalha os pelos outra vez.';
    else if (rl.load >= .86) { m = 'Está cheio. Lava-o e volta a colar.'; cheio = true; }
    else if (this.washed && rl.load < .08) m = 'Lavado e seco. Cola outra vez.';
    else if (rl.load >= .5) m = 'Já apanha menos. Ainda dá.';
    else if (rl.load > .02) m = 'Cola bem. Continua.';
    else m = 'Carrega e arrasta sobre o tecido.';
    if (m !== this.state.dmMsg || cheio !== this.state.dmCheio) this.setState({ dmMsg: m, dmCheio: cheio });
  }
  kick() { if (!this.raf) this.raf = requestAnimationFrame(this.tick); }
  tick() {
    this.raf = 0;
    var more = false, i, h;
    if (this.anim) {
      for (i = 0; i < this.hairs.length; i++) {
        h = this.hairs[i];
        if (!h.alive && h.t > 0) { h.t = Math.max(0, h.t - .085); if (h.t > 0) more = true; }
        else if (h.alive && h.t < 1) { h.t = Math.min(1, h.t + .05); if (h.t < 1) more = true; }
      }
      var rl = this.rl;
      if (rl.wash > 0) {
        rl.wash = Math.max(0, rl.wash - .03);
        rl.load = this.washFrom * rl.wash;
        var keep = Math.round(rl.marks.length * (rl.wash > .1 ? .96 : 0));
        rl.marks.length = keep;
        if (rl.wash > 0) more = true; else { rl.load = 0; rl.marks = []; this.status(); }
      }
      this.anim = more;
    }
    this.draw();
    if (more) this.raf = requestAnimationFrame(this.tick);
  }
  draw() {
    var c = this.ctx, W = this.W, H = this.H; if (!c || !W) return;
    var d = this.dpr, k = this.k;
    c.setTransform(1, 0, 0, 1, 0, 0);
    if (this.bgc) c.drawImage(this.bgc, 0, 0); else { c.fillStyle = '#242321'; c.fillRect(0, 0, W * d, H * d); }
    c.setTransform(d, 0, 0, d, 0, 0);
    c.lineCap = 'round';
    var rl = this.rl, rx = rl.x * W, ry = rl.y * H;
    for (var i = 0; i < this.hairs.length; i++) {
      var h = this.hairs[i]; if (h.t <= 0) continue;
      var x = h.x * W, y = h.y * H, a = h.o * h.t;
      if (!h.alive && h.fly) { var q = 1 - h.t; x = h.fly.x0 + (h.fly.x1 - h.fly.x0) * q; y = h.fly.y0 + (h.fly.y1 - h.fly.y0) * q; }
      var L = h.l * k, ca = Math.cos(h.a), sa = Math.sin(h.a);
      var x2 = x + L * ca, y2 = y + L * sa, mx = (x + x2) / 2 - sa * h.b * k * .5, my = (y + y2) / 2 + ca * h.b * k * .5;
      c.globalAlpha = a; c.strokeStyle = h.c; c.lineWidth = h.w * k;
      c.beginPath(); c.moveTo(x, y); c.quadraticCurveTo(mx, my, x2, y2); c.stroke();
    }
    c.globalAlpha = 1;
    this.drawRoller(c, rx, ry);
  }
  drawRoller(c, cx, cy) {
    var L = this.RL, T = this.RT, rl = this.rl, s = T / 100;
    c.save();
    c.fillStyle = 'rgba(0,0,0,.38)';
    c.beginPath(); c.ellipse(cx + 6 * s, cy + T * 1.18, L * .52, T * .28, 0, 0, Math.PI * 2); c.fill();
    var x0 = cx - L / 2, y0 = cy - T / 2, r = T / 2;
    var g = Math.round(227 - rl.load * 30);
    c.fillStyle = 'rgb(' + g + ',' + (g - 3) + ',' + (g - 10) + ')';
    c.strokeStyle = '#2B2A28'; c.lineWidth = Math.max(1.5, T * .03);
    c.beginPath(); c.moveTo(x0 + r, y0); c.lineTo(x0 + L - r, y0); c.arc(x0 + L - r, cy, r, -Math.PI / 2, Math.PI / 2); c.lineTo(x0 + r, y0 + T); c.arc(x0 + r, cy, r, Math.PI / 2, Math.PI * 1.5); c.closePath(); c.fill(); c.stroke();
    c.save(); c.clip();
    for (var i = 0; i < rl.marks.length; i++) {
      var m = rl.marks[i], mx = cx + m.x * L * .9, my = cy + m.y * T * .8, ml = m.l * L * .5;
      c.strokeStyle = m.c; c.globalAlpha = .85; c.lineWidth = 1.4;
      c.beginPath(); c.moveTo(mx, my); c.quadraticCurveTo(mx + ml * .5, my - ml * .4, mx + ml * Math.cos(m.a), my + ml * .4 * Math.sin(m.a)); c.stroke();
    }
    c.globalAlpha = 1;
    if (rl.wash > 0) {
      var wx = x0 + L * (1 - rl.wash) * 1.2 - L * .1;
      c.fillStyle = 'rgba(255,255,255,.55)'; c.fillRect(wx, y0, L * .16, T);
    }
    c.strokeStyle = 'rgba(255,255,255,.75)'; c.lineWidth = T * .08;
    c.beginPath(); c.moveTo(x0 + L * .12, y0 + T * .24); c.lineTo(x0 + L * .88, y0 + T * .24); c.stroke();
    c.restore();
    c.fillStyle = '#FFFEFB'; c.strokeStyle = '#2B2A28'; c.lineWidth = Math.max(1.5, T * .03);
    c.beginPath();
    c.moveTo(x0 - T * .08, cy + T * .1);
    c.bezierCurveTo(x0 + L * .06, cy + T * 1.05, x0 + L * .3, cy + T * 1.3, cx, cy + T * 1.3);
    c.bezierCurveTo(x0 + L * .7, cy + T * 1.3, x0 + L * .94, cy + T * 1.05, x0 + L + T * .08, cy + T * .1);
    c.bezierCurveTo(x0 + L * .7, cy + T * .42, x0 + L * .3, cy + T * .42, x0 - T * .08, cy + T * .1);
    c.closePath(); c.fill(); c.stroke();
    c.fillStyle = '#E3DED4';
    [x0 - T * .02, x0 + L + T * .02].forEach(function (ex) { c.beginPath(); c.ellipse(ex, cy + T * .08, T * .15, T * .66, 0, 0, Math.PI * 2); c.fill(); c.stroke(); });
    if (rl.wash > 0) {
      c.fillStyle = 'rgba(250,247,241,.9)';
      for (var j = 0; j < 7; j++) {
        var dx = x0 + L * (.1 + j * .13), dy = y0 - T * (.3 + ((1 - rl.wash) * 3 + j * .37) % 1.2);
        c.beginPath(); c.ellipse(dx, dy, T * .05, T * .08, 0, 0, Math.PI * 2); c.fill();
      }
    }
    c.restore();
  }

  renderVals() {
    var s = this.state, self = this;
    var gal = {};
    this.GAL.forEach(function (g, i) {
      var on = i === s.img;
      gal['a' + i] = on ? g.alt : ''; gal['c' + i] = on ? 'on' : '';
      gal['t' + i] = on ? 'th sel' : 'th'; gal['p' + i] = on ? 'true' : 'false';
      gal['k' + i] = self.picks[i];
    });
    var cur = this.GAL[s.img];
    var rvc = function (k) { return !s.armed ? '' : (s.seen[k] ? 'rv in' : 'rv'); };
    var o = s.open;
    return {
      yes: true, logoH: 40, logoFt: 40,
      preco: 15.9, precoCapa: 39.9, precoForra: 54.9, precoTaca: 11.9,
      feats: ['Lava-se em água morna e volta a colar, sem recargas', 'Estojo com tampa: não apanha pó no porta-luvas', '10,1 × 6,5 cm, cabe no bolso da porta'],
      trust: [{ icone: 'envio', texto: 'Envio grátis' }, { icone: 'devolucao', texto: 'Devolução em 14 dias' }, { icone: 'prazo', texto: '10 a 15 dias úteis' }],
      specs: [{ rotulo: 'Medidas', valor: '10,1 × 6,5 cm (estojo fechado)' }, { rotulo: 'Material', valor: 'Estojo em plástico ABS, rolo em silicone adesivo' }, { rotulo: 'Cor', valor: 'Branco' }, { rotulo: 'Recargas', valor: 'Não precisa: lava-se e volta a colar' }],
      factos: [{ titulo: 'Envio grátis', texto: 'Para Portugal e 13 países da UE, sem mínimo.' }, { titulo: '10 a 15 dias úteis', texto: 'Sai de armazém internacional.' }, { titulo: 'Devolução em 14 dias', texto: 'Sem justificação. Trocamos ou devolvemos o dinheiro.' }, { titulo: 'Resposta em 1 dia útil', texto: 'caomigo.pt@gmail.com' }],
      gal: gal, capT: cur.t, capD: cur.d,
      ctaLabel: s.added ? 'Adicionado ao carrinho' : 'Adicionar ao carrinho',
      ctaShort: s.added ? 'Adicionado' : 'Adicionar ao carrinho',
      ctaCls: s.added ? 'cta-l on' : 'cta-l', added: s.added,
      parLabel: s.par ? 'Capa adicionada' : 'Adicionar a Capa',
      add: this.add, addPar: this.addPar, liveMsg: s.live,
      hasCart: s.cart > 0, cart: s.cart, bdgCls: s.bump ? 'bdg bump' : 'bdg',
      cartLabel: s.cart > 0 ? 'Carrinho, ' + s.cart + (s.cart === 1 ? ' artigo' : ' artigos') : 'Carrinho, vazio',
      menuExp: s.menu ? 'true' : 'false', toggleMenu: this.toggleMenu, mnavCls: s.menu ? 'mnav is-open' : 'mnav',
      rowLavar: o.lavar ? 'row is-open' : 'row', expLavar: o.lavar ? 'true' : 'false', tLavar: this.tLavar,
      rowCaixa: o.caixa ? 'row is-open' : 'row', expCaixa: o.caixa ? 'true' : 'false', tCaixa: this.tCaixa,
      rowEnvio: o.envio ? 'row is-open' : 'row', expEnvio: o.envio ? 'true' : 'false', tEnvio: this.tEnvio,
      rv: { foto: rvc('foto'), demo: rvc('demo'), ph: rvc('ph'), passos: rvc('passos'), det: rvc('det'), faq: rvc('faq'), relh: rvc('relh'), rel: rvc('rel'), fac: rvc('fac') },
      setRoot: this.setRoot, setCv: this.setCv, setCta: this.setCta,
      dmDown: this.dmDown, dmMove: this.dmMove, dmUp: this.dmUp, dmLeave: this.dmLeave, dmKey: this.dmKey,
      lavar: this.lavar, recomecar: this.recomecar,
      dmMsg: s.dmMsg, stCls: s.dmCheio ? 'dm-st alerta' : 'dm-st', hintCls: s.hint ? 'dm-hint' : 'dm-hint off',
      barCls: s.bar ? 'mbar on' : 'mbar', barHidden: s.bar ? 'false' : 'true'
    };
  }
}
(window.CMG = window.CMG || {}).pages = window.CMG.pages || {};
window.CMG.pages['rolo'] = Component;
if (window.CMG.mountAll) window.CMG.mountAll();
})();
